










































export default
  name: 'TopThirdPage'

  data: () ->
    active: false

  mounted: () ->
    window.addEventListener('scroll', @scroll)
  destroyed: () ->
    window.removeEventListener('scroll', @scroll)

  methods: {
    scroll:() ->
      @active = false
      if document.querySelector('.third_page')
        if window.scrollY > document.querySelector('.third_page').offsetTop - window.innerHeight / 2
          @active = true
  }
